import { Component } from '../flags.js'

export const User = Component.flex.ai_center.fixed.t20.r20.fs11.div()
export const Profile = Component.mr20.uppercase.ls1.sapphire5.div()
export const SignOut = Component.ba.c_pointer.uppercase.ls1.mono.b_sapphire2.sapphire5.bg_none.b_rad20.ph15.pv5.fs10.div()
export const Modes = Component.as_center.flex.w50.ai_center.jc_between.ml60.mt30.mr_auto.div()
export const Unauthorized = Component.w100vw.h100vh.flex.flex_column.ai_center.jc_center.div()
export const Loader = Component.w100vw.h100vh.flex.ai_center.jc_center.div()
export const Holder = Component.sapphire3.mono.absolute.fs13.div()